import Input from 'components/Input'
import useClickOutside from 'hooks/useClickOutside'
import Calendar from 'icons/indexed-icons/Calendar'
import React, { useRef, useState } from 'react'
import { Calendar as CalendarPicker } from 'react-date-range'
import styled from 'styled-components'
import { format } from 'date-fns';
import theme from 'themes'

const CalendarInputContainer = styled.label`
    position: absolute;
    right: 2rem;
    bottom: 3rem;
   .rdrCalendarWrapper{
        box-shadow: ${theme.colors.lightGrey8} 0px 7px 29px 0px;
        background-color: ${props=>props.theme.colors.white};
   }
`

const InputContainer = styled.label`
    cursor: pointer;
    z-index: -1;
    .input {
    user-select: none;
    cursor: pointer;
    position: relative;
    };
    position: relative;
    .icon--calendar{
        position: absolute;
        right: 1rem;
        top: .025rem;
    }
`

const Container = styled.div`
    position: relative;
    cursor: pointer;
    &.input{
        cursor: pointer;
    }
`

const Main = styled.div`
   position: relative;
`

type Props = {
    handleDateChange: (date: Date) => void;
    dateFormat?: string;
    date?: string
} 
const DatePicker = ( {handleDateChange, dateFormat, date } : Props): JSX.Element => {
    const [datePicker, setDatePicker] = useState(false);
    const [selectedDate, setSelectedDate] = useState<string>(date||'')

    const ref = useRef(null)
    const handleCalendarPicker = () => {
        setDatePicker(!datePicker)
    }
    useClickOutside(ref, handleCalendarPicker)

    const handleChange = (date: Date) => {
        handleDateChange(date)
        const formattedDate = format(date, dateFormat || 'MM/dd/yyyy');
        setSelectedDate(formattedDate);
        setDatePicker(!datePicker)
    }
    return (
        <Main className='date-picker'>
            <Container onClick={() => {
                handleCalendarPicker()
            }}>
                <InputContainer >
                    <Input className='input' value={selectedDate} placeholder='Requested delivery date' disabled />
                    <Calendar />
                </InputContainer>
            </Container>

            {
                datePicker ?
                    <CalendarInputContainer ref={ref}>
                        <CalendarPicker date={date ? new Date(date): new Date()} minDate={new Date()} onChange={handleChange} />
                    </CalendarInputContainer>
                    : <></>

            }

        </Main>
    )
}

export default DatePicker
